import { Injectable } from "@angular/core";
import { AngularFirestore, AngularFirestoreCollection } from "@angular/fire/compat/firestore";
import { AngularFireFunctions } from "@angular/fire/compat/functions";
import * as moment from "moment";
import * as momentTZ from "moment-timezone";
import { BehaviorSubject } from "rxjs";
import { Expert } from "../models/expert.model";

@Injectable({
    providedIn: 'root',
})
export class OnCallScheduleCollectionService {

    private scheduleArray = new BehaviorSubject([]);
    currentScheduleArray = this.scheduleArray.asObservable();

    private onCallWeeklySchedule = new BehaviorSubject([]);
    currentOnCallWeeklySchedule = this.onCallWeeklySchedule.asObservable();

    constructor(
        private angularFirestore: AngularFirestore,
        private angularFunctions: AngularFireFunctions
    ) { }

    async getSpecialtyOnCall(specialtyID: string) {
        try {
            const collection: AngularFirestoreCollection = this.angularFirestore.collection('OnCallSchedule');

            let onCall = [];

            let today = moment();
            let todayStart = Number(moment(today).hours(0).minutes(0).seconds(0).format('x'));
            let todayEnd = Number(moment(today).hours(23).minutes(59).seconds(59).format('x'));

            await collection.ref
                .where('specialty_id', '==', specialtyID)
                .where('timestamp', '>=', todayStart)
                .where('timestamp', '<=', todayEnd)
                .orderBy('timestamp', 'asc')
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        const docData = {
                            id: doc.id,
                            ...doc.data()
                        }
                        onCall.push(docData)
                    });
                }).catch(err => console.log("getSpecialtyOnCall query 1 error: " + err));

            if (onCall.length > 0) {
                return onCall[0];
            } else {
                return null;
            }

        } catch (error) {
            console.log('getSpecialtyOnCallAsync(): ' + JSON.stringify(error));
        }
    }

    async replaceExpertCoverage(coverageID: string, expert: Expert) {
        try {
            const collection: AngularFirestoreCollection = this.angularFirestore.collection('OnCallSchedule');

            await collection.ref
                .doc(coverageID)
                .update({
                    expert_id: expert.id,
                    first_name: expert.first_name,
                    last_name: expert.last_name
                }).catch(err => console.log("replaceExpertCoverage query 1 error: " + err));

        } catch (error) {
            console.log(error);
        }
    }

    async getOnCallScheduleBySpecialty(specialtyID: string) {
        try {
            const begginingOfWeekMonday = momentTZ.tz(new Date(), "America/Los_Angeles").startOf('isoWeek').format();
            // Monday
            let startDate = Number(momentTZ.tz(begginingOfWeekMonday, "America/Los_Angeles").format('x'));
            //Sunday
            let endOfWeek = Number(momentTZ.tz(begginingOfWeekMonday, "America/Los_Angeles").add(6, 'days').endOf('day').format('x'));

            let expertSpecialties = [];

            const collection: AngularFirestoreCollection = this.angularFirestore.collection('OnCallSchedule');

            await collection.ref
                .where('specialty_id', '==', specialtyID)
                .where('timestamp', '>=', startDate)
                .where('timestamp', '<=', endOfWeek)
                .orderBy('timestamp', 'asc')
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        const docData = {
                            id: doc.id,
                            ...doc.data()
                        }
                        expertSpecialties.push(docData)
                    });
                }).catch(err => console.log("getOnCallScheduleBySpecialty query 1 error: " + err));

            this.updateOnCallScheduleBySpecialty(expertSpecialties);
        } catch (error) {
            console.log(error);
        }
    }

    async getOnCallWeelyScheduleBySpecialty(specialtyID: string) {
        try {
            let weeklySchedule = [];
            this.onCallWeeklySchedule.next(weeklySchedule);

            const collection: AngularFirestoreCollection = this.angularFirestore.collection('OnCallWeeklySchedule');

            await collection.ref
                .where('specialty_id', '==', specialtyID)
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        const docData = {
                            id: doc.id,
                            ...doc.data()
                        }
                        weeklySchedule.push(docData)
                    });
                }).catch(err => console.log("getOnCallWeelyScheduleBySpecialty query 1 error: " + err));

            this.onCallWeeklySchedule.next(weeklySchedule);
        } catch (error) {
            console.log(error);
        }
    }

    async replaceWeeklySchedule(weeklyData: any) {
        try {
            const collection: AngularFirestoreCollection = this.angularFirestore.collection('OnCallWeeklySchedule');

            await collection.ref
                .doc(weeklyData.id)
                .update({
                    specialty_id: weeklyData.specialty_id,
                    week: weeklyData.week,
                }).catch(err => console.log("replaceWeeklySchedule save 1 error: " + err));

        } catch (error) {
            console.log(error);
        }
    }

    async createNewWeeklySchedule(weeklyData: any) {
        try {
            const collection: AngularFirestoreCollection = this.angularFirestore.collection('OnCallWeeklySchedule');

            await collection.ref
                .add(JSON.parse(JSON.stringify(weeklyData)))
                .catch(err => console.log("createNewWeeklySchedule save 1 error: " + err));

            this.getOnCallWeelyScheduleBySpecialty(weeklyData.specialty_id)
        } catch (error) {
            console.log(error);
        }
    }

    updateOnCallScheduleBySpecialty(onCallList: any) {
        let newOnCallList = onCallList;
        newOnCallList.sort((a, b) => parseFloat(a.timestamp) - parseFloat(b.timestamp));
        this.scheduleArray.next(newOnCallList);
    }

    async test() {
        try {
            // const callable = this.angularFunctions.httpsCallable('createNewOnCallScheduleWeek');

            // callable({
            //     specialty_id: 'yFKni22Qx3rm3NCwFFV1',
            // })
            //     .toPromise()
            //     .then((result) => console.log('test createNewOnCallScheduleWeek', result))
            //     .catch((error) => console.log('test createNewOnCallScheduleWeek', error));

            return true;
        } catch (error) {
            console.log(error);
        }
    }
}